
/**
 * Metrics collection for Web Vitals
 */
import { NavigationTiming } from './types';
import { reportMetric } from './core';

/**
 * Collect First Contentful Paint metric
 */
export function collectFCP() {
  try {
    if ('performance' in window) {
      const paintEntries = performance.getEntriesByType('paint');
      for (const entry of paintEntries) {
        if (entry.name === 'first-contentful-paint') {
          reportMetric('FCP', entry.startTime);
          break;
        }
      }
    }
  } catch (e) {
    console.error('Error collecting FCP:', e);
  }
}

/**
 * Collect metrics that should be measured after page load
 */
export function collectPostLoadMetrics() {
  try {
    setTimeout(() => {
      if ('performance' in window) {
        // Navigation Timing API
        const navEntry = performance.getEntriesByType('navigation')[0] as NavigationTiming;
        
        if (navEntry) {
          // Time To First Byte
          const ttfb = navEntry.responseStart - navEntry.requestStart;
          reportMetric('TTFB', ttfb);
          
          // Document Load Time
          const domLoad = navEntry.domContentLoadedEventEnd - navEntry.fetchStart;
          reportMetric('DCL', domLoad);
          
          // Full Page Load Time
          const pageLoad = navEntry.loadEventEnd - navEntry.fetchStart;
          reportMetric('Load', pageLoad);
        }
        
        // Resource Load Time
        const resources = performance.getEntriesByType('resource');
        let totalResourceLoad = 0;
        
        resources.forEach((resource) => {
          totalResourceLoad += resource.duration;
        });
        
        reportMetric('ResourceLoad', totalResourceLoad);
      }
    }, 0);
  } catch (e) {
    console.error('Error collecting post-load metrics:', e);
  }
}
